// eslint-disable-next-line @typescript-eslint/no-namespace
namespace searchForm {
    export const CONSTRUCT = [
      {
        'display_id': 'fiscal_year',
        component: 'InputArea',
        col: 0,
        props: {
          labelName: '決算年度',
          labelText: '決算年度',
          inputType: 'number'
        },
        row: 0,
        sizeX: 3,
        sizeY: 1
      },
      {
        'display_id': 'period',
        component: 'InputArea',
        col: 4,
        props: {
          labelName: '期',
          labelText: '期',
          inputType: 'number'
        },
        row: 0,
        sizeX: 1,
        sizeY: 1
      },
      {
        'display_id': 'construction_no',
        component: 'InputArea',
        col: 5,
        props: {
          labelName: '工事番号',
          labelText: '工事番号',
          inputType: 'number'
        },
        row: 0,
        sizeX: 1,
        sizeY: 1
      },
      {
        'display_id': 'construction_subject_id',
        component: 'MasterSelectControl',
        col: 6,
        dblookup: 'm_construction_subject',
        props: {
          leftSideInputName: 'construction_subject_id',
          dialogTitle: '工事科目選択',
          label: '工事科目',
          isLeftSideInputReadOnly: true,
          isRightSideInputReadOnly: true,
          columns: [],
          body: []
        },
        row: 0,
        sizeX: 3,
        sizeY: 1
      },
      {
        'display_id': 'title_disp',
        component: 'InputArea',
        col: 0,
        props: {
          labelName: '工事名',
          labelText: '工事名',
          inputType: 'text'
        },
        row: 1,
        sizeX: 4,
        sizeY: 1
      },
      {
        'display_id': 'customer_id',
        component: 'MasterSelectControl',
        col: 4,
        dblookup: 'm_customer',
        props: {
          leftSideInputName: 'customer_id',
          isLeftSideInputCodeVisible: false,
          isRightSideInputReadOnly: true,
          dialogTitle: '元請名選択',
          label: '元請名',
          columns: [],
          body: []
        },
        row: 1,
        sizeX: 6,
        sizeY: 1
      },
      {
        'display_id': 'sales_staff_id',
        component: 'MasterSelectSetControl',
        dblookup: 'm_staff',
        row: 2,
        col: 0,
        sizeX: 3,
        sizeY: 1,
        props: {
          name: 'sales_staff_id',
          dialogTitle: '担当者（営業）選択',
          outPutData: [
            {
              label: '担当者名（営業）',
              name: 'display_name',
              isReadOnly: true
            }
          ],
          isRightSideInputReadOnly: true
        }
      },
      {
        'display_id': 'construction_division_id',
        component: 'MasterSelectControl',
        dblookup: 'm_department',
        row: 2,
        col: 4,
        sizeX: 6,
        sizeY: 1,
        props: {
          leftSideInputName: 'construction_division_id',
          isLeftSideInputCodeVisible: false,
          isRightSideInputReadOnly: true,
          dialogTitle: '工事部門選択',
          label: '工事部門',
          columns: [],
          body: []
        }
      }
    ];
  }
  export const searchFormConstruct = searchForm.CONSTRUCT;  